"use client";

import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { homePageMenuList } from "../constants";
import { AnimatedBackground } from "@/components/ui/animated-background";
import { motion } from "framer-motion";

export function SimpleHeader() {
  const pathname = usePathname();

  return (
    <div className="flex items-center justify-between px-6 h-full" data-cursor-zone="header">
      {/* Logo with layoutId - matching pill design */}
      <motion.div layoutId="fellou-logo-section" className="flex items-center gap-3 ">
        <div className="relative">
          <motion.div layoutId="fellou-logo">
            <Image
              src="/favicon.ico"
              alt="fellou"
              width={32}
              height={32}
              unoptimized
              className="w-8 h-8 relative z-10 drop-shadow-2xl"
            />
          </motion.div>
        </div>
        <motion.div layoutId="fellou-text" className="text-[24px] font-bold text-white">
          Fellou
        </motion.div>
      </motion.div>

      {/* Navigation with AnimatedBackground */}
      <div className="flex items-center">
        <AnimatedBackground
          defaultValue={pathname}
          className="rounded-lg bg-white/20"
          transition={{
            type: "spring",
            bounce: 0.2,
            duration: 0.3,
          }}
          enableHover
        >
          {homePageMenuList.map((item, index) => (
            <Link
              href={item.href}
              key={`menu-item-${index}`}
              target={
                item.href === "/" || item.href === "/use-cases/" || item.href === "/pricing/" ? undefined : "_blank"
              }
              data-id={item.href}
              className="px-3 py-1.5 text-white/70 transition-colors duration-300 hover:text-white text-[14px] font-medium relative inline-flex"
            >
              {item.title}
            </Link>
          ))}
        </AnimatedBackground>
      </div>

      {/* Spacer to balance logo on the left */}
      <div className="w-[120px]" aria-hidden />
    </div>
  );
}
